var $ = require('../internals/export'); // `Math.isubh` method
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703


$({
  target: 'Math',
  stat: true
}, {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});